export default {"src":"/_next/static/media/dimension-logo-dark.8fd84ec2.svg","height":52,"width":193,"blurWidth":0,"blurHeight":0};